module.exports = __webpack_public_path__ + "static/media/supersociedades.a6728a4c.jpg";